<template>
  <v-stepper
    :value="step"
    class="elevation-0"
    style="background-color: var(--v-background-base)"
  >
    <v-stepper-header>
      <v-stepper-step
        color="blue darken-2"
        step="1"
        :complete="checkCompletedSteps(1)"
        >Select Start Date</v-stepper-step
      >

      <v-divider></v-divider>

      <!-- <v-stepper-step
        color="blue darken-2"
        step="2"
        :complete="checkCompletedSteps(2)"
      >Select Days</v-stepper-step>

      <v-divider></v-divider> -->

      <v-stepper-step
        color="blue darken-2"
        step="2"
        :complete="checkCompletedSteps(2)"
        >Add Products</v-stepper-step
      >
      <v-divider v-if="!isAccountCustomerOnly"></v-divider>

      <v-stepper-step
        v-if="!isAccountCustomerOnly"
        color="blue darken-2"
        step="3"
        :complete="checkCompletedSteps(3)"
        >Confirm</v-stepper-step
      >
    </v-stepper-header>
  </v-stepper>
</template>
<script>
export default {
  name: "StandingProgress",
  props: {
    step: null,
    markComplete: Boolean,
  },

  methods: {
    checkCompletedSteps(currentStep) {
      if (currentStep < this.step) {
        return true;
      }

      if (currentStep == 2 && this.markComplete) {
        return true;
      }
      return false;
    },
  },

  computed: {
    isAccountCustomerOnly() {
      if (
        this.$store.getters.retrieveIsCashCustomer ||
        this.$store.getters.retrieveIsCncCustomer ||
        this.$store.getters.retrieveIsPaymentWithOrderCustomer
      ) {
        return false;
      }
      return true;
    },
  },
};
</script>
